import Vue from "vue";
import config from "@/config";
import errorTags from "@/errorTags";
import router from "@/router";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    language: "en",
    _loading: {
      login: false,
      addSecondary:false,
      logout: false,
      updatePassword: false,
      manualDeposit: false,
      getPromo: false,
      addWithdrawTicket: false,
      getStatement: false,
      getMemberGameResult: false,
      launchWbet: false,
      launchNeko: false,
      launchLive22:false,
      launchKingkong: false,
      launchPeg:false,
      launchUuslot:false,
      getRealTimeTrans:false,
      getNekoResult:false,
      getLive22Result: false,
      getKingkongResult: false,
      getPegResult:false,
      getUuResult:false,
      getNekoGameList: false,
      getPegGameList:false,
      launchLg: false,
    },
    transferDetails: [],
    betHistory: {
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    livecasinoResult:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    slotResult:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    promoList : {
      data: {
        PROMOTION_LIST: [],
        BANK_ACC: [],
        SOCIAL_ACC: []
      }
    },
    sbResult:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    refreshKey: 0,
    slotSelected: 0,
    promoSelected: "",
    gameSelected: "",
    promoDetail : [],
    settlementDate: "",
    topten: [],
    account: "",
    balance: 0,
    gameToken: 0,
  },
  mutations: {
    updateLanguage(state, payload) {
      state.language = payload;
    },
    uTransferDetails(state, payload) {
      state.transferDetails = payload;
    },
    uBetHistory(state, payload) {
      state.betHistory = payload;
    },
    uLivecasinoResult(state, payload) {
      state.livecasinoResult = payload;
    },
    uSlotResult(state, payload) {
      state.slotResult = payload;
    },
    uPromo(state, payload){
      // state.promoList = payload;
      state.promoList.data.PROMOTION_LIST = payload.data.PROMOTION_LIST
      state.promoList.data.BANK_ACC = payload.data.BANK_ACC
      state.promoList.data.SOCIAL_ACC = payload.data.SOCIAL_ACC
    },
    uRebateResult(state, payload){
      state.rebateResult = payload
    },
    uSbResult(state, payload){
      state.sbResult = payload
    },
    update(state, payload) {
      state.account = payload.data;
    },
    delete(state) {
      state.account = "";
      state.bankList = [];
      state.balance = 0;
      state.gameToken = 0;
      state.livecasinoResult = {
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      }
      state.slotResult = {
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      },
      state.promoList = {
        data: {
          PROMOTION_LIST: [],
          BANK_ACC: [],
          SOCIAL_ACC: []
        }
      },
      state.promoSelected = ""
      state.gameSelected = ""
      state.promoDetail = []
      state.rebateResult ={
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      },
      state.sbResult ={
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      },
      state.downlineList = {
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      }
      state.inbox = [];
      // window.sessionStorage.clear();
    },
    loading(state, payload) {
      if ("action" in payload) {
        const action = payload.action;
        const status = payload.status;
        state._loading[action] = status;
      }
    },
    updateBalance(state, payload) {
      state.balance = payload.available_balance;
      // state.gameToken = payload.game_token
    },
    updateUsername(state, payload){
      state.account.nickname = payload
    },
    updateRefreshKey(state, payload) {
      state.refreshKey = payload;
    },
    updateSlotSelected(state, payload){
      state.slotSelected = payload;
    },
    updatePromoSelected(state, payload){
      state.promoSelected = payload
    },
    updateGameSelected(state, payload){
      state.gameSelected = payload
    },
    updatePromoDetail(state, payload){
      state.promoDetail = payload
    },
    updateSettlementDate(state, payload){
      state.settlementDate = payload
    },
    updateTopTen(state, payload) {
      state.topten = payload;
    },
  },
  actions: {
    // updatePanel(context, payload){
    //   context.commit("updateIsPanel", payload)
    // },
    setLanguage(context, payload) {
      i18n.locale = payload;
      context.commit("updateLanguage", payload);
    },
    sTransferDetails(context, payload) {
      context.commit("uTransferDetails", payload);
    },
    sBetHistory(context, payload) {
      context.commit("uBetHistory", payload);
    },
    sLivecasinoResult(context, payload){
      context.commit("uLivecasinoResult", payload)
    },
    sSlotResult(context, payload){
      context.commit("uSlotResult", payload)
    },
    sPromo(context, payload){
      context.commit("uPromo", payload)
    },
    sRebateResult(context, payload){
      context.commit("uRebateResult", payload)
    },
    sSbResult(context, payload){
      context.commit("uSbResult", payload)
    },
    setRefreshKey(context, payload) {
      context.commit("updateRefreshKey", payload);
    },
    setSlotSelected(context, payload){
      context.commit("updateSlotSelected", payload);
    },
    setPromoSelected(context, payload){
      context.commit("updatePromoSelected", payload)
    },
    setGameSelected(context, payload){
      context.commit("updateGameSelected", payload)
    },
    setPromoDetail(context, payload){
      context.commit("updatePromoDetail", payload)
    },
    settlementDate(context, payload){
      context.commit("updateSettlementDate", payload);
    },
    login(context, user) {
      const url = config.memberLogin();
      const body = {
        login_id: user.login_id,
        password: user.password,
        client_ip: user.client_ip,
        login_source: user.login_source
      };
      const feedback = {
        success: false,
        status: errorTags.login.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.login == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          context.commit("loading", { action: "login", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "login", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var sessionToken = null;
                  var data = null;
                  try {
                    sessionToken = successResponse.data.value[0].session_token;
                    data = successResponse.data.value[0];
                    
                    if (sessionToken) {
                      context.commit("update", { data });
                      // let account_id = user.username
                      // let auth_token = sessionToken
                      // let app_id = user.app_id
                      // commit("getInbox", {account_id, auth_token, app_id})
                      // dispatch('getInbox', null, { root: true })
                      resolve(feedback);
                    } else {
                      context.commit("delete");
                      feedback.success = false;
                      feedback.status = errorTags.login.failed;
                      reject(feedback);
                    }
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.login.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  // router.push("/").catch(err=>{});
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "login", status: false });
              context.commit("delete");
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    logout(context) {
      const feedback = {
        success: true,
        status: errorTags.logout.succeed
      };
      return new Promise(resolve => {
        context.commit("delete");
        resolve(feedback);
      });
    },
    addSecondary(context, user) {
      const url = config.addSecondary();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
        new_login_id: user.new_login_id
      };
      const feedback = {
        success: false,
        status: errorTags.addSecondary.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.addSecondary.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("new_login_id" in user)) {
          feedback.status = errorTags.addSecondary.secondaryIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.addSecondary.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.new_login_id.length <= 0) {
          feedback.status = errorTags.addSecondary.secondaryIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addSecondary == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addSecondary", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addSecondary",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    context.commit("updateUsername", user.new_login_id);
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.addSecondary.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addSecondary",
                status: false
              });
              context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBalance(context, user) {
      const url = config.getBalance();
      const body = {
        member_id: user.member_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getBalance.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.status = errorTags.getBalance.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.member_id.length <= 0) {
          feedback.status = errorTags.getBalance.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getBalance == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getBalance", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getBalance", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  if(successResponse.body.status == "1"){
                    feedback.success = successResponse.body.status == "1"
                  }else{
                    feedback.success = false
                  }
                } else {
                  if(successResponse.body.status == 1){
                    feedback.success = successResponse.body.status == 1
                  }else{
                    feedback.success = false
                  }
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value[0];
                    context.commit("updateBalance", feedback.data);
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        // context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }

                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }

                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getBalance", status: false });
              // context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
              router.push("/").catch(err => {}); 
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePassword(context, user) {
      const url = config.updatePassword();
      const body = {
        login_id: user.login_id,
        password: user.password,
        new_password: user.new_password,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.updatePassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.updatePassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("new_password" in user)) {
          feedback.status = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.updatePassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.new_password.length <= 0) {
          feedback.status = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePassword == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updatePassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    manualDeposit(context, user) {
      const url = config.manualDeposit();
      const body = {
        member_id: user.member_id,
        amount: user.amount,
        attachment_path: user.attachment_path,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token
      };
      const feedback = {
        success: false,
        status: errorTags.manualDeposit.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.status = errorTags.manualDeposit.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("amount" in user)) {
          feedback.status = errorTags.manualDeposit.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.status = errorTags.manualDeposit.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.amount.length <= 0) {
          feedback.status = errorTags.manualDeposit.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.manualDeposit == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "manualDeposit",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "manualDeposit",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "manualDeposit",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberTicketList(context, user) {
      const url = config.getMemberTicketList();
      const body = {
        member_id: user.member_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberTicketList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.status = errorTags.getMemberTicketList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.member_id.length <= 0) {
          feedback.status = errorTags.getMemberTicketList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMemberTicketList == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getMemberTicketList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMemberTicketList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMemberTicketList", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPromo(context, user) {
      const url = config.getPromo();
      const body = {
        member_id: user.member_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getPromo.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.status = errorTags.getPromo.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.member_id.length <= 0) {
          feedback.status = errorTags.getPromo.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getPromo == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getPromo", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getPromo", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getPromo", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addWithdrawTicket(context, user) {
      const url = config.addWithdrawTicket();
      const body = {
        member_id: user.member_id,
        amount: user.amount,
        auth_token: user.auth_token
      };
      const feedback = {
        success: false,
        status: errorTags.addWithdrawTicket.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.status = errorTags.addWithdrawTicket.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("amount" in user)) {
          feedback.status =
            errorTags.addWithdrawTicket.withdrawal_amount_required;
          reject(feedback);
          canRequest = false;
        }

        if (user.member_id.length <= 0) {
          feedback.status = errorTags.addWithdrawTicket.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.amount.length <= 0) {
          feedback.status =
            errorTags.addWithdrawTicket.withdrawal_amount_required;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addWithdrawTicket == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "addWithdrawTicket",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addWithdrawTicket",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                feedback.isFreeC = successResponse.body.isFreeC;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addWithdrawTicket",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberTransferDetails(context, user) {
      const url = config.getMemberTransferDetails();
      const body = {
        member_id: user.member_id,
        working_date: user.working_date,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.member_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberGameResult(context, user) {
      const url = user.url
      const body = {
        member_id: user.member_id,
        working_date: user.working_date,
        page_size: user.page_size,
        page_number: user.page_number,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.status = errorTags.getMemberGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.member_id.length <= 0) {
          feedback.status = errorTags.getMemberGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMemberGameResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getMemberGameResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMemberGameResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMemberGameResult", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPlatformWinLose(context, user) {
      const url = config.getPlatformWinLose();
      const body = {
        member_id: user.member_id,
        working_date: user.working_date,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.member_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberStatement(context, user) {
      const url = config.getMemberStatement();
      const body = {
        member_id: user.member_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.member_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPromoStatement(context, user) {
      const url = config.getPromoStatement();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        working_date: user.working_date,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchNeko(context, user) {
      const url = config.launchNeko();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchNeko.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchNeko.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchNeko.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchNeko == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchNeko", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchNeko", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchNeko", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchLive22(context, user) {
      const url = config.launchLive22();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchLive22.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchLive22.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchLive22.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchLive22 == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchLive22", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchLive22", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchLive22", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchKingkong(context, user) {
      const url = config.launchKingkong();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code,
        is_mobile: user.is_mobile
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchKingkong.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchKingkong.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchKingkong.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchKingkong == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchKingkong", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchKingkong", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchKingkong", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchUuslot(context, user) {
      const url = config.launchUuslot();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchUuslot.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchUuslot.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchUuslot.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchUuslot == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchUuslot", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchUuslot", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchUuslot", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchPeg(context, user) {
      const url = config.launchPeg();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code,
        mobile:user.mobile
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchPeg.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchPeg.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchPeg.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchPeg == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchPeg", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchPeg", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchPeg", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchWbet(context, user) {
      const url = config.launchWbet();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        type: user.type,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchWbet.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchWbet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchWbet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchWbet == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchWbet", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchWbet", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchWbet", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getNekoResult(context, user) {
      const url = config.getNekoResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getNekoResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getNekoResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getNekoResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getNekoResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getNekoResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getNekoResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getNekoResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getNekoResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  // feedback.success = successResponse.body.status == "1";
                  feedback.success = successResponse.status == "200";
                } else {
                  feedback.success = successResponse.status == 200;
                  // feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.statusText;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getNekoResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getLive22Result(context, user) {
      const url = config.getLive22Result();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getLive22Result.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getLive22Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getLive22Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getLive22Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getLive22Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getLive22Result == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getLive22Result", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getLive22Result", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getLive22Result", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getKingkongResult(context, user) {
      const url = config.getKingkongResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
        lang_code: user.lang_code,
        game_code: user.game_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getKingkongResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getKingkongResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getKingkongResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getKingkongResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getKingkongResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getKingkongResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getKingkongResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getKingkongResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getKingkongResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPegResult(context, user) {
      const url = config.getPegResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getPegResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getPegResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getPegResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getPegResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getPegResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getPegResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getPegResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getPegResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getPegResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getUuResult(context, user) {
      const url = config.getUuResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getUuResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getUuResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getUuResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getUuResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getUuResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getUuResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getUuResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getUuResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getUuResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getRealTimeTrans(context, user) {
      const url = config.getRealTimeTrans();
      const body = {
        method: user.method
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getRealTimeTrans.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (this.state.user._loading.getRealTimeTrans == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getRealTimeTrans", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getRealTimeTrans", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getRealTimeTrans", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getNekoGameList(context, user) {
      const url = config.getNekoGameList();
      const body = {
        player_id: user.player_id,
        provider_code: user.provider_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getNekoGameList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getNekoGameList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getNekoGameList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getNekoGameList == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getNekoGameList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getNekoGameList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  // feedback.success = successResponse.body.status == "1";
                  feedback.success = successResponse.status == "200";
                } else {
                  // feedback.success = successResponse.body.status == 1;
                  feedback.success = successResponse.status == 200;
                }
                feedback.status = successResponse.statusText;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getNekoGameList", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPegGameList(context, user) {
      const url = config.getPegGameList();
      const body = {
        player_id: user.player_id,
        provider_code: user.provider_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getPegGameList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getPegGameList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getPegGameList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getPegGameList == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getPegGameList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getPegGameList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  // feedback.success = successResponse.body.status == "1";
                  feedback.success = successResponse.status == "200";
                } else {
                  // feedback.success = successResponse.body.status == 1;
                  feedback.success = successResponse.status == 200;
                }
                feedback.status = successResponse.statusText;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getPegGameList", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchLg(context, user) {
      const url = config.launchLg();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        mobile: user.mobile,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchLg.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchLg.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchLg.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchLg == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchLg", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchLg", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchLg", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
  }
};
